
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const units = state => state.units;
const getsingle = state => param =>state.units.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  units,
  getsingle
};